export default "__VITE_ASSET__HrQtbJfw__"